import { MathUtils } from "~/utils/MathUtils";

interface ImperialFractionProps {
  value: number | string | undefined;
  isConverted?: boolean;
  className?: string;
}

export const approxPrefix = (isConverted: boolean) => {
  return isConverted ? "≈ " : "";
};

export const ImperialFraction = ({ value, isConverted = false, className }: ImperialFractionProps) => {
  let parsedValue;
  if (!value) {
    return undefined;
  }

  if (typeof value === "string") {
    let val = isConverted ? value.split(" ")[1] : value;
    parsedValue = parseFloat(val.replace(/\s/g, "").replace(",", "."));
  } else {
    parsedValue = value;
  }

  if (Number.isNaN(parsedValue)) {
    return undefined;
  }

  const wholeNumber = Math.floor(parsedValue);
  const rest = parsedValue - wholeNumber;

  if (rest === 0) {
    return (
      <span>
        {approxPrefix(isConverted)}
        {wholeNumber}
      </span>
    );
  }

  const fraction = MathUtils.decimalToFraction(rest);

  return (
    <span>
      {approxPrefix(isConverted)} {wholeNumber > 0 && wholeNumber} <sup>{fraction?.numerator}</sup>/<sub>{fraction?.denominator}</sub>
    </span>
  );
};

export default ImperialFraction;
 